import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import store from '@/store'

export default {
  resetRecommendation({ commit }) {
    commit(types.RESET_RECOMMENDATION)
  },
  resetTranslations({ commit }) {
    commit(types.RESET_TRANSLATIONS)
  },
  setCriteriaChanged({ commit }, value) {
    commit(types.SET_CRITERIA_CHANGED, value)
  },
  async setStep({ commit, state, dispatch }, value) {
    if (value !== 99) {
      commit(types.SET_STEP, value)
      commit(types.SET_VISITED_STEP, value)
    }
    if (state.criteriaChanged) {
      // if anything was changed, save the Scan Pro Criteria
      let profile = store.getters['auth/profile']
      let data = {
        businessId: profile.location.Id,
        criteria: state.scanProCriteria,
        checklist: state.scanProChecklist
      }
      await startLoading(dispatch, 'saveScanProConfiguration', () => http.post('scanpro/SaveScanProConfiguration', data))
      commit(types.SET_CRITERIA_CHANGED, false)
    }
  },
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  updateRecommendation({ commit }, data) {
    commit(types.UPDATE_RECOMMENDATION, data)
  },
  prepRecommendation({ commit }, firm) {
    commit(types.PREP_RECOMMENDATION, firm)
  },
  async getRecommendations({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getRecommendations', () =>
      http.get('testdrive/testdriveRecommendations', {
        params: data
      })
    )
    commit(types.SET_RECOMMENDATIONS, r.data)
    return r.data
  },
  async getRecommendation({ commit, dispatch }, testDriveRecommendation) {
    const r = await startLoading(dispatch, 'getRecommendation', () => http.get(`testdrive/testdriveRecommendation?testDriveRecommendation=${testDriveRecommendation}`))
    commit(types.SET_RECOMMENDATION, r.data)
    return r.data
  },
  async saveRecommendation({ dispatch, state }) {
    const r = await startLoading(dispatch, 'saveRecommendation', () =>
      http.post('testdrive/saveTestDriveRecommendation', {
        firm: state.recommendation.firm,
        testDriveRecommendation: state.recommendation.testDriveRecommendation,
        recommendation: state.recommendation.recommendation,
        driveType: state.recommendation.driveType,
        vehicleMake: state.recommendation.vehicleMake,
        recommendationText: state.recommendation.recommendationText
      })
    )
    return r.data
  },
  async deleteRecommendation({ dispatch }, testDriveRecommendation) {
    const r = await startLoading(dispatch, 'deleteRecommendation', () => http.get(`testdrive/deleteTestdriveRecommendation?testDriveRecommendation=${testDriveRecommendation}`))
    return r.data
  },
  async saveNewTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveNewTranslation', () => http.post('language/addTranslation', data))
    return r.data
  },
  async saveTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTranslation', () => http.post('language/saveTranslation', data))
    return r.data
  },
  async getTranslations({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTranslations', () => http.get(`language/translations?translationType=${data.translationType}&languageCode=${data.languageCode}`))
    commit(types.SET_TRANSLATIONS, r.data)
    return r.data
  },
  async deleteTranslation({ dispatch }, translation) {
    const r = await startLoading(dispatch, 'deleteTranslation', () => http.get(`language/deleteTranslation?translation=${translation}`))
    return r.data
  },
  resetTestDriveResultType({ commit }) {
    commit(types.RESET_RESULTTYPE)
  },
  updateTestDriveResultType({ commit }, data) {
    commit(types.UPDATE_RESULTTYPE, data)
  },
  async getTestDriveResultTypes({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getTestDriveResultTypes', () =>
      http.get('lookup/testdriveResultType', {
        params: options
      })
    )
    commit(types.SET_RESULTTYPES, r.data)
    return r.data
  },
  async getTestDriveResultType({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestDriveResultType', () => http.get(`lookup/testdriveResultType?testdriveResultType=${id}`))
    commit(types.SET_RESULTTYPE, r.data)
    return r.data
  },
  async saveTestDriveResultType({ state, dispatch }) {
    const r = await startLoading(dispatch, 'saveTestDriveResultType', () => http.post('lookup/saveTestdriveResultType', state.testdriveResultType))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/actions.js